module.exports = __webpack_public_path__ + "static/media/first picture.6c8536ae.png";